import { useContext } from "react";
import { MSALProviderContext } from "./MSALContextProvider.js";
const useMSALContext = () => {
  const context = useContext(MSALProviderContext);
  if (context === void 0) {
    throw new Error("useAgent must be used within an AgentProvider");
  }
  return context;
};
export {
  useMSALContext
};
